import React from "react";
import PageHeader from "./layout/PageHeader";

const PrivacyPolicy = ({
  activeLocation,
  locations = [],
  onChangeLocation,
  companyDisplayName,
  currentUser,
  onLogout,
  onLock,
}) => {
  return (
    <div className="privacy-policy-container page-shell">
      <PageHeader
        title="Privacy Policy"
        subtitle="How ALBERTai and Unity Global Care handle your data."
        icon={<span style={{ fontWeight: 800, fontSize: "18px" }}>🔒</span>}
        activeLocation={activeLocation}
        locations={locations}
        onChangeLocation={onChangeLocation}
        companyDisplayName={companyDisplayName}
        currentUser={currentUser}
        onLogout={onLogout}
        onLock={onLock}
      />

      <div
        style={{
          padding: "32px",
          maxWidth: "900px",
          margin: "0 auto",
          color: "#333",
          lineHeight: "1.6",
          background: "#fff",
          borderRadius: "12px",
          border: "1px solid #e5e7eb",
          boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "24px" }}>
          <h1>Terms and Conditions</h1>
          <h2>ALBERTai</h2>
          <h2>Our Commitment To Privacy</h2>
        </div>

      <div>
        <p>
          ALBERTai (Albert) respects your privacy and is committed to protecting
          your personal information. ALBERTai is a software platform/Website
          designed provide families with an Aging-In-Place Score and also match
          interested persons with need-based service providers. Persons may
          search our website, WWW.GOALBERT.COM(“Website”), to learn about
          federal, state, and local need-based government and charitable
          programs and services in their area (each a “Benefit” and
          collectively, “Benefits”), and, depending upon the provider, may be
          able to apply for Benefits through our Website (the “Services”).
        </p>

        <p>
          ALBERTai is owned by Unity Global Care Inc. a Corporation, organized
          in the State of Delaware.
        </p>

        <p>
          In this Privacy Policy Statement (“Policy”), we describe the
          information that we collect from visitors and members to our Website
          and Application. This Policy governs the use of our Website, as well
          as ALBERTai (www.goalbertai.com), and our products and services
          offered through this Website (collectively, “Services”). Your use of
          our Website or the Services, and any dispute over privacy, is subject
          to this Policy and our Terms of Service, including its applicable
          limitations on damages and the resolution of disputes. This Policy is
          incorporated by reference to the Terms of Service of our Website.
        </p>

        <p>
          This Website and the Services are designed for persons in the United
          States.
        </p>

        <h3>
          What Information Do We Collect from You and How Do We Use Your
          Information?
        </h3>
        <p>
          We may collect information about you directly from you and from third
          parties, as well as automatically through your use of our Website or
          Services.
        </p>

        <h3>Information We Collect Directly From You</h3>
        <p>
          You are free to search through and use the Website without providing
          any information about yourself. If you would like to save programs or
          providers to your personalized favorites list or apply for Benefits
          through our Website, then we will require you to create a member
          account. To create a member account, we will collect your email
          address, a password you create and other information identifying your
          membership with you.
        </p>
        <p>
          You may apply for, or contact a third party concerning, certain
          third-party Benefits through our Website; the third party – not
          ALBERTai — determines the scope of the information that it would like
          for us to collect from you. Depending upon the particular Benefit, and
          in accordance with the third party’s instructions, we may request
          information such as the following from you through our Website:
        </p>
        <ul>
          <li>Name</li>
          <li>Mailing Address</li>
          <li>Phone number</li>
          <li>Date of birth</li>
          <li>Gender</li>
          <li>
            Whether you have proof of identification, such as a Social Security
            Number, passport or state driver’s license (but not the details
            associated with that identification)
          </li>
          <li>Information about children (include birthdate)</li>
          <li>Living situation (house/apt., shelter, etc.)</li>
          <li>Information about your health and wellness</li>
          <li>
            Additional program specific eligibility criteria, which will vary
            depending upon the program
          </li>
          <li>Whether the person is pregnant</li>
          <li>History of drug/alcohol abuse</li>
          <li>Insurance coverage</li>
          <li>Criminal history</li>
          <li>
            Income information (employment, government benefits, child support,
            etc.)
          </li>
        </ul>
        <p>
          The program/agency determines the application process; if you do not
          want to apply through our Website, please contact the program/agency
          to determine if there is an alternative application process.
        </p>
        <p>
          We also may collect information from you in order to update your
          account. For example, if you think that information on our Website is
          inaccurate or out-of-date, you may click on the “Report A Change”
          button and provide us additional and/or revised information. We use
          this information only for the purpose of reviewing and updating our
          Website. The comments that you submit in this section are not publicly
          available, but we may share your comments (anonymously) with the
          Benefit provider so that we may update our Website.
        </p>
        <p>
          When you enroll in our Short Message Service (“SMS”) program, we will
          collect information such as your mobile phone number, mobile carrier,
          date, time, and content of the messages, and other information
          provided by you. Your mobile carrier may also collect data from you,
          as reflected in their own privacy policies.
        </p>

        <h3>Information We May Receive from You about Others</h3>
        <p>
          We may receive your information from a third party, including receipt
          of your name, contact information and other details as part of sharing
          information found on our website or a referral to a Benefit through
          the website.
        </p>
        <p>
          We may also collect information from you about someone else. If you
          provide information about someone else, you must ensure that you are
          authorized to disclose that information to ALBERTai or Unity, and
          that, without ALBERTai taking any further steps required by applicable
          data privacy laws, ALBERTai may collect, use and disclose that
          information for the purposes described in this Policy.
        </p>

        <h3>Information We Collect Through Your Use of Our Website</h3>
        <p>
          We use cookies and other tracking technologies to automatically
          collect information about you when you visit our Website or use our
          Services. Specifically, we may collect the following information: your
          IP address, browser type, domain name, operating system, date and time
          of visit, referring website, time spent on and/or logged in to the
          Website, and pages viewed. Please see the section below entitled
          “Cookies & Other Tracking Technologies” for additional information.
        </p>

        <h3>Use of Your Information</h3>
        <p>
          We use your information primarily to apply for the Benefits that you
          have requested. We may use your profile information to identify other
          programs and services that we believe would be of interest to you, and
          we may email you about those programs and services. We will not,
          however, apply for any Benefits on your behalf without your knowledge.
          We also may use your information to respond to your requests or
          inquiries from users, to communicate with you about your use of our
          Services, and for similar customer-service-related purposes. We also
          may use your information to assist us in maintaining our Website, such
          as for troubleshooting and technical support purposes, and to improve
          our Website and Services and to better understand how users access and
          use our Website and Services, on an aggregated and individualized
          basis.
        </p>
        <p>
          We also may use aggregate information to assist us in determining
          products and services needed to add to our Website.
        </p>

        <h3>Sharing Your Information</h3>
        <p>
          We share your information at your direction; with the limited
          exceptions discussed below, we do not share your information with
          third parties unless you agree in advance. We will not share your
          personal information under any circumstance with any third parties for
          their direct marketing purposes unless you are first notified. In this
          section, we describe the potential uses of your information in greater
          detail:
        </p>
        <p>
          <strong>With Third Parties That Provide Benefits:</strong> As stated
          above, we primarily share your information, including your personal
          information, with the third parties that provide the Benefits that you
          would like to receive. Specifically, at your direction, we will submit
          your application to the appropriate third parties. The third party,
          not ALBERTai, will evaluate your eligibility to obtain service from
          its program. The third party’s use of your personal information will
          be governed by the third party’s privacy policy. ALBERTai or Unity
          does not have any control over your information once it is submitted
          to a third party for receipt of Benefits. For example, if you are
          interested in transportation services, then we will share your
          information, at your direction, with agencies that provide
          transportation that may fit your particular situation. In some
          instances, your information may be shared with third parties who are
          providing grants, financial assistance, or other support for the
          programs you are applying for.
        </p>
        <p>
          In sharing your personal information with third party providers, as
          stated above, such information will be provided to each and every
          third party that you request. By consenting to this sharing, you
          further agree that the third parties themselves may also collaborate
          and share your information solely in support of the service that you
          are seeking. To the extent that any other information is generated
          from the collaboration and such information is stored in the ALBERTai
          Platform, such information will be deemed to be covered by this
          privacy policy. ALTHOUGH WE SHARE INFORMATION WITH THIRD PARTIES AT
          YOUR DIRECTION, WE ARE NOT RESPONSIBLE FOR THE ACTS AND OMISSIONS OF
          THIRD PARTIES.
        </p>
        <p>
          <strong>To Perform Services on Our Behalf:</strong> We may hire vendor
          companies to provide limited services on our behalf, such as website
          hosting, payment processing, sending postal and electronic mail,
          providing technical support, and to assist us in providing the
          products and services that you request from us. We only provide those
          service providers with the information necessary to perform the
          requested service.
        </p>
        <p>
          <strong>Third Party Support System:</strong> If you submit a support
          request via a third-party support service we may use, you will be
          asked to provide certain information including without limitation your
          name and email address. Support requests are operated by the
          third-party support and contact request management service provided by
          the support organization. Participation in this service is entirely at
          your discretion and governed by the support organizations Privacy
          Policy.
        </p>
        <p>
          <strong>
            With Your Friends and Other Persons at Your Direction:
          </strong>{" "}
          You have the option of sending a friend information about Benefits
          listed on our Website. We will collect your email address, your
          friend’s email address, and a message that you would like to share
          with your friend. We will send the Benefit information to your friend
          along with your message and email address.
        </p>
        <p>
          <strong>Consolidation of Company:</strong> If we are acquired by or
          merged with another company, if substantially all of our assets are
          transferred to another company, or as part of a bankruptcy proceeding,
          we may transfer the information we have collected from you to the
          other company.
        </p>
        <p>
          <strong>To Protect Ourselves/For Legal Purposes:</strong> We also may
          disclose your information to protect our rights and property, to
          prevent against fraud and abuse, and to protect other users of our
          services. For example, if we believe that you are misusing our Website
          or taking an action that is harming our Website (e.g., uploading a
          virus to our Website), we may share your information with law
          enforcement to protect our Services. We also may disclose your
          information as permitted or required by law, for example, in response
          to court orders, subpoenas, or other requests from government
          agencies.
        </p>

        <h3>Cookies & Other Tracking Technologies</h3>
        <p>
          We and our third-party service providers use cookies and other
          tracking mechanisms to track information about your use of our Website
          or Services. We may combine this information with other personal
          information we collect from you (and our third-party service providers
          may do so on our behalf).
        </p>
        <p>
          Currently, our systems do not recognize browser “do-not-track”
          requests. You may, however, disable certain tracking as discussed in
          this section (e.g., by disabling cookies).
        </p>
        <p>
          When you come to the Website, our web server sends a cookie to your
          computer. Cookies are alphanumeric identifiers that we transfer to
          your computer’s hard drive through your web browser for record-keeping
          purposes. There are two types of cookies: session-based and
          persistent-based cookies. We also may permit certain third-party
          cookies to be placed on our Website.
        </p>
        <p>
          <strong>Session Cookies.</strong> Session cookies exist only during an
          online session. They disappear from your computer when you close your
          browser or turn off your computer. We use session cookies to allow our
          systems to uniquely identify you while you are logged into the
          Website. This allows us to process your online transactions and
          requests, and to verify your identity, after you have logged in, as
          you move through our Website.
        </p>
        <p>
          <strong>Persistent cookies.</strong> Persistent cookies remain on your
          computer after you have closed your browser or turned off your
          computer. We may use persistent cookies to track aggregate and
          statistical information about user activity, which may be combined
          with other user information.
        </p>
        <p>
          <strong>Third Party Analytics.</strong> We may use automated devices
          and applications, such as Google Analytics, to evaluate usage of our
          Website. We also may use other analytic means to evaluate our
          Services. We use these tools to help us improve our Services,
          performance, and user experiences. These entities may use cookies and
          other tracking technologies to perform their services. We do not share
          your personal information with these third parties. We do not have
          access to or control over these third-party cookies nor does this
          Privacy Policy cover such third parties’ use of data. In addition,
          ALBERTai offers functionality that allows certain customers with their
          own site integration to use automated devices and applications, such
          as Google Analytics, and other analytic means to evaluate the
          Services. For additional information about the Customer’s use of
          third-party analytics, please visit the privacy policy of the ALBERTai
          customer that is associated with your use of ALBERTai. You may be able
          to opt-out or restrict the collection or use of information by some
          commonly used tracking pixels and services. The following links are
          provided for your convenience:
        </p>
        <ul>
          <li>
            Google Analytics –{" "}
            <a
              href="https://tools.google.com/dlpage/gaoptout/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://tools.google.com/dlpage/gaoptout/
            </a>
          </li>
          <li>
            Facebook Pixel –{" "}
            <a
              href="https://www.facebook.com/settings?tab=ads"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.facebook.com/settings?tab=ads
            </a>
          </li>
          <li>
            Bing Pixel –{" "}
            <a
              href="https://choice.microsoft.com/en-US/opt-out"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://choice.microsoft.com/en-US/opt-out
            </a>
          </li>
        </ul>
        <p>
          <strong>Disabling Cookies.</strong> Most web browsers automatically
          accept cookies, but if you prefer, you can edit your browser options
          to block them in future. The Help portion of the toolbar on most
          browsers will tell you how to prevent your computer from accepting new
          cookies, how to have the browser notify you when you receive a new
          cookie, or how to disable cookies altogether. Website visitors who
          disable their web browsers’ ability to accept cookies will be able to
          browse the Website; however, you must enable cookies to use most of
          our Services.
        </p>

        <h3>Opting Out of Communications</h3>
        <p>
          <strong>Email.</strong> If you have created an account with us or
          requested to receive information from us, we may send you email about
          topics and opportunities that we believe may be of interest to you. At
          any time, you may unsubscribe from our emails by using the link
          contained in the email. If you opt-out of receiving emails about
          recommendations or other information we think may interest you, we may
          still send you e-mails about your account or any Services you have
          requested or received from us.
        </p>
        <p>
          <strong>Phone.</strong> If you no longer wish to receive information
          from us, please email info@myalbertai.com or call 800-314-0255.
        </p>
        <p>
          <strong>Text Messages.</strong> If you no longer wish to participate
          in our SMS program, send a text message with one of the keywords:
          STOP, END, QUIT, CANCEL, OR UNSUBSCRIBE to 800-314-0255. You may
          receive one final message from us confirming that you have been
          inactivated in our system. Following such confirmation message, no
          additional messages will be sent by us unless you reactivate your SMS
          subscription.
        </p>

        <h3>Updating Your Information</h3>
        <p>
          You may edit your profile information at any time by emailing us at
          info@myalbertai.com.
        </p>

        <h3>Security of Your Information</h3>
        <p>
          We want the information that you submit to us to be secure. We use
          industry-standard techniques to safeguard the information that you
          provide to us through our Website. Notwithstanding our commitment to
          your information, please be aware that there is a risk that others
          could find a way to thwart our security systems or the security
          systems of the third parties that host our server. As a result, we
          cannot ensure or warrant the security or privacy of any information
          that you choose to submit to us.
        </p>
        <p>
          You should take steps to protect against unauthorized access to your
          password, phone, and computer by, among other things, signing off
          after using a shared computer, choosing a robust password that nobody
          else knows or can easily guess, and keeping your log-in and password
          private. We are not responsible for any lost, stolen, or compromised
          passwords or for any activity on your account via unauthorized
          password activity.
        </p>

        <h3>Short Message Service</h3>
        <p>
          You may opt to enroll in our SMS program. By enrolling, you represent
          that you are the account holder for the mobile telephone number(s)
          that you provide to us. You are responsible for notifying us
          immediately if you change your mobile telephone number.
        </p>
        <p>
          We provide this service without a fee; however, message and data rates
          may apply from your mobile carrier. By providing your consent to
          participate in this program, you approve such charges from your mobile
          carrier. ALBERTai and Unity is not responsible for any charges related
          to the use of this service.
        </p>
        <p>
          ALBERTai and Unity does not guarantee the successful or timely
          delivery of text messages by your mobile carrier. Delivery of
          information and content to a mobile device may fail due to a variety
          of circumstances or conditions. You understand and acknowledge that
          network services, including but not limited to mobile network
          services, are outside of ALBERTai’s control, and ALBERTai and Unity is
          not responsible or liable for issues arising from them.
        </p>
        <p>
          If you request to be referred to a program, and you use text messages
          as your primary form of communication with ALBERTai, in certain
          circumstances text messages may include protected health information
          (“PHI”), by the nature of the programs you are referred to. Since text
          messaging is unencrypted, there is a risk that this PHI could be
          intercepted or viewed by third parties, including others who access
          your device. When you choose to receive text messages from us, you do
          so at your own risk.
        </p>
        <p>
          ALBERTai and Unity reserves the right to terminate the SMS program in
          whole or in part, at any time and without notice.
        </p>

        <h3>User Generated Content</h3>
        <p>
          We maintain a blog on our Website open to public comment. Interested
          persons also may comment on programs after creating a username; we do
          not permit anonymous comments. WPHConnect.org is not responsible for
          the privacy of any information that you choose to submit through our
          blog, or for the accuracy of any information contained in those
          postings. Any information that you disclose through our blog becomes
          public information. We cannot prevent such information from being used
          in a manner that may violate this Policy, the law, or your personal
          privacy.
        </p>

        <h3>Children’s Privacy</h3>
        <p>
          Our Website is not intended for persons under the age of 13, and we do
          not knowingly collect information from persons under the age of 13. If
          we learn that a person under the age of 13 has created an account or
          directly applied for programs through our Website, then we will remove
          that information from our systems. Please be advised, however, that
          certain programs offered by third parties may be applicable to persons
          under the age of 13 or may require us to provide information about the
          children in your household. In those situations, we only collect
          information about persons under the age of 13 directly from the
          registered user, which must be a person over the age of 13.
        </p>

        <h3>Your California Privacy Rights</h3>
        <p>
          The CCPA provides consumers (California residents) with specific
          rights regarding their personal information. This section describes
          your CCPA rights and explains how to exercise those rights. For
          consumers where we operate as a service provider, we will direct you
          to exercise your rights through our customer.
        </p>
        <p>
          You also have the right to request that we disclose certain
          information to you or take other actions concerning your personal
          information, including:
        </p>
        <ul>
          <li>
            The right to know the personal information collected about you,
            including the right to receive it in a data portable format;
          </li>
          <li>
            The right to opt-out of the sale of your personal information,
            although we currently do not sell your personal information and thus
            do not offer the right to opt-out;
          </li>
          <li>
            The right of deletion of your personal information, subject to
            certain limitations under applicable law;
          </li>
          <li>
            The right not to be discriminated against for individuals who choose
            to exercise any of their rights under the CCPA.
          </li>
        </ul>
        <p>
          To exercise these rights, please submit a request by emailing
          info@myalbertai.com, including your email address and phone number.
          Once we receive your request, we will review it, determine whether we
          can verify your identity, and process the request accordingly. If we
          need additional information to verify your identity, we will let you
          know. We will respond to your request within 45 days of receipt or
          notify you if we require additional time.
        </p>
        <p>
          If you would prefer, you may designate an authorized agent to make a
          request on your behalf.
        </p>
        <p>
          If you are a California resident under the age of 18, and a registered
          user of any website where this policy is posted, California Business
          and Professions Code Section 22581 permit you to request and obtain
          removal of content or information you have publicly posted. To make
          such a request, please send an e-mail with a detailed description of
          the specific content or information to info@myalbertai.com. Please
          be aware that such a request does not ensure complete or comprehensive
          removal of the content or information you have posted and that there
          may be circumstances in which the law does not require or allow
          removal even if requested.
        </p>

        <h3>Changes to this Privacy Policy</h3>
        <p>
          We will post changes to this Policy to this Website. Changes will
          become effective upon posting. If we make a material change to this
          Policy, we will endeavor to notify our account holders by highlighting
          the change upon posting and sending an email address to our account
          holders at the most current email address.
        </p>

        <h3>Contact Us</h3>
        <p>
          Please contact us at info@myalbertai.com if you have any questions
          regarding this Policy.
        </p>
        <p>Last Revised: November 26, 2025</p>
        <br />
        <br />

        <div style={{ textAlign: "center", marginBottom: "40px" }}>
          <h1>END USER TERMS OF SERVICES</h1>
        </div>

        <p>
          Welcome to the ALBERTai a website owned and operated by Unity Global
          Care Inc,, a Delaware Corporation – and thank you for visiting. We
          hope you enjoy the experience!
        </p>

        <p>
          THESE TERMS AND CONDITIONS (THE “TERMS”) ARE A LEGAL CONTRACT BETWEEN
          YOU (“YOU”) AND ALBERTAI, A WEBSITE AND PLATFORM OWNED AND OPERATED BY
          UNITY GLOBAL CARE INC. (UNITY), A DELAWARE CORPORATION (“ALBERTAI” OR
          “US” OR “OUR” OR “WE”). THE TERMS EXPLAIN HOW YOU ARE PERMITTED TO USE
          AND ACCESS THE SITE LOCATED AT THE URL: WWW.GOALBERTAI.COM AS WELL AS
          ALL ASSOCIATED SITES LINKED TO WWW.GOALBERTAI.COM BY UNITY, ITS
          SUBSIDIARIES AND AFFILIATED COMPANIES (COLLECTIVELY, THE “SITE”) AND
          ALL SERVICES (AS DEFINED HEREIN) AND ANY SOFTWARE THAT WE PROVIDE TO
          YOU THAT ALLOWS YOU TO ACCESS THE SITE OR SERVICES FROM A DEVICE (AN
          “APPLICATION”). BY USING THE SITE OR THE SERVICES, YOU ARE AGREEING TO
          ALL THE TERMS; IF YOU DO NOT AGREE WITH ANY OF THESE TERMS, DO NOT
          ACCESS OR OTHERWISE USE THE SITE, ANY SERVICES AVAILABLE THROUGH THE
          SITE OR ANY INFORMATION CONTAINED ON THE SITE. BY ACCEPTING THESE
          TERMS, OR BY ACCESSING OR USING THE SITE, YOU AGREE TO BE BOUND BY
          THESE TERMS. IF YOU ACCEPT OR AGREE TO THESE TERMS ON BEHALF OF A
          COMPANY OR OTHER LEGAL ENTITY, YOU REPRESENT AND WARRANT THAT YOU HAVE
          THE AUTHORITY TO BIND SUCH COMPANY OR OTHER LEGAL ENTITY TO THESE
          TERMS, AND IN SUCH EVENT, “YOU” AND “YOUR” WILL REFER AND APPLY TO
          SUCH COMPANY OR OTHER LEGAL ENTITY.
        </p>

        <h3>KEY TERMS</h3>
        <p>
          “Account” means any ALBERTai accounts or instances created by You or
          on your behalf within the Site for use of the Services.
        </p>
        <p>
          “Authorized End User” means, collectively You and any of your
          individual, agents, or contractors accessing or using the Site or
          Services, under the rights granted to You pursuant to these Terms. An
          individual may be an Authorized End User of the Site or Services,
          whether or not they are accessing the Site or Services in an
          authenticated manner.
        </p>
        <p>
          “Community Based Organization” or “CBO” means an organization or
          program that provides community, social, or other services to
          individuals that is listed on our Site. Ownership of a CBO may be
          claimed by an Authorized End User of our Site and Services at
          https://www.goalalbertai.com/claims. In addition to all other terms in
          this End User Terms of Service, CBOs and their Authorized End Users
          are also subject to the additional “Specific Terms for Community Based
          Organizations” documented in Section 12 of this End User Terms of
          Service.
        </p>
        <p>
          “Confidential Information” means any and all non-public information
          disclosed by one party to the other party in any form or medium,
          whether oral, written, graphical or electronic, pursuant to these
          Terms, that has been identified as confidential or that by the nature
          of the circumstances surrounding disclosure ought reasonably to be
          treated as confidential.
        </p>
        <p>
          “Documentation” means text and/or graphical documentation, whether in
          electronic or printed format, that describe the features, functions
          and operation of the Services, which materials are designed to
          facilitate use of the Services and which are provided by ALBERTai to
          You in accordance with these Terms.
        </p>
        <p>
          “Materials” mean collectively all the text, data, information,
          software, graphics, photographs and more, including the Documentation,
          the proprietary platform and ALBERTai API through which ALBERTai
          offers the Site and Services to You in a ‘software as-a-service’ form.
          Materials include any and all intellectual property embodied in the
          Materials.
        </p>
        <p>
          “Open Source Software” means all software that is available under the
          GNU Affero General Public License (AGPL), GNU General Public License
          (GPL), GNU Lesser General Public License (LGPL), Mozilla Public
          License (MPL), Apache License, BSD licenses, or any other license that
          approved by the Open Source Initiative (www.opensource.org).
        </p>
        <p>
          “Services” means any and all services, tools, software, content,
          applications and functionalities as may be provided by ALBERTai from
          time to time through the Site.
        </p>
        <p>
          “Your Content” means the data, media and content submitted, stored,
          posted, displayed, or otherwise transmitted by You and/or any
          Authorized End Users on or through the Site, but does not include any
          data you collect through use of or in connection with the Services.
        </p>

        <h3>CHANGES TO TERMS</h3>
        <p>
          We may alter the Materials and Services We offer You and/or choose to
          modify, suspend or discontinue the Site or Services at any time and
          without notifying You. We may also change, update, add or remove
          provisions (collectively, “Modifications”) of these Terms from time to
          time. We will inform You of any Modifications by posting them on the
          Site. If You object to any such Modifications, Your sole recourse
          shall be to cease using the Site. Continued use of the Site and
          Services following notice of any such Modifications indicates You
          acknowledge and agree to be bound by the Modifications. Also, these
          Terms may be superseded by expressly designated legal notices or terms
          located on particular pages of the Site. These expressly designated
          legal notices or terms are incorporated into these Terms and supersede
          the provision(s) of these Terms that are designated as being
          superseded.
        </p>

        <h3>GENERAL USE OF THE SITE</h3>
        <p>
          We invite You to use the Site for individual, consumer purposes
          (“Permitted Purposes”) – enjoy!
        </p>
        <p>
          By using the Site, You promise that You are at least 13 years of age.
          If You are not yet 18 years old, You must have the permission of an
          adult to use the Site and agree to its Terms, and that adult must be a
          parent or legal guardian who is willing be responsible for Your use of
          the Site. In these Terms we are granting You a limited, personal,
          non-exclusive and non-transferable right to access and use and to
          display the Materials; Your right to use the Materials is conditioned
          on Your compliance with these Terms. You have no other rights in the
          Site or any Materials and You may not modify, edit, copy, reproduce,
          create derivative works of, reverse engineer, alter, enhance or in any
          way exploit any of the Site or Materials in any manner. If we permit
          You, in writing in advance, to make copies of any part of the Site,
          You agree not to remove or alter any of Our copyright and other
          proprietary notices as they appear on the Site. Further, You
          explicitly agree that You have not been granted any license to use
          ALBERTai’s proprietary platform or ALBERTai API (such use would
          require a separate paid subscription agreement). Unfortunately, if You
          breach any of these Terms the above right of access and use will
          terminate automatically.
        </p>

        <h3>ACCOUNT REGISTRATION</h3>
        <p>
          We appreciate You visiting the Site and allow You to do just that –
          stop by and leisurely check it out without even registering with Us!
          However, in order to access certain password-restricted areas of the
          Site and to use certain Services and Materials offered on and through
          the Site, You must successfully register an Account with Us.
        </p>
        <p>
          If You want an Account with Us, You must submit a working email
          address and a preferred password through the Account registration page
          on the Site. You may also provide additional, optional information so
          that We can provide You a more customized experience when using the
          Site –but, We will leave that decision with You. If you subscribe to
          certain Services additional information such as billing address and
          payment information will also be required. Once You submit the
          required registration information, We alone will determine whether or
          not to approve Your proposed Account. If approved, You will be sent an
          e-mail detailing how to complete Your registration. For so long as You
          use the Account, You agree to provide true, accurate, current, and
          complete information which can be accomplished by logging into Your
          Account and making relevant changes directly or contacting Us using
          the below contact information and We can make the changes for You.
          And, if You forget Your password – no worries as We will happily send
          a password update to Your provided email address.
        </p>
        <p>
          You are responsible for complying with these Terms when You access the
          Site, whether directly or through any Account that You may setup
          through or on the Site. Because it is Your Account, it is Your
          responsibility to obtain and maintain all equipment and services
          needed for access to and use of The Site as well as pay all related
          charges. It is also Your responsibility to maintain the
          confidentiality of Your password(s), including any password of a
          third-party site that We may allow You to use to access the Site.
          Should You believe Your password or security for The Site has been
          breached in any way, You must immediately notify Us.
        </p>

        <h3>USE OF THE SERVICES BY YOU AND AUTHORIZED END USERS</h3>
        <p>
          Under certain circumstances, You and Your Authorized End Users may be
          presented with the ability to send referrals or inquiries directly to
          Community Based Organizations (“CBOs”) that are also Authorized End
          Users of our Site and Services. If You are a “covered entity” or
          “business associate” as those terms are defined in regulations
          promulgated under the Health Insurance Portability and Accountability
          Act of 1996 (“HIPAA”), at 45 CFR 160.103, You are responsible for
          ensuring that disclosures that you make to any CBO comply with HIPAA
          requirements. For the avoidance of doubt, ALBERTai is not a business
          associate of any CBO, and does not sign a “business associate
          agreement” or other written agreement governing the use or disclosure
          of “protected health information” with any CBO. Between You and
          ALBERTai, You are solely responsible for entering into a business
          associate agreement with any entity if, in Your sole interpretation,
          one is necessary to disclose or receive information to that entity.
        </p>
        <p>
          You agree that You will not, and will not permit any Authorized End
          Users to: (i) copy or duplicate any of the Materials in any form,
          regardless of technique (e.g., screen-scraping, downloading, printing
          except as permitted in this Agreement and the Documentation or
          otherwise); (ii) decompile, disassemble, reverse engineer or otherwise
          attempt to obtain or perceive the source code from which any software
          component of any of the Materials is compiled or interpreted, or apply
          any other process or procedure to derive the source code of any
          software included in the Materials, or attempt to do any of the
          foregoing, and You acknowledge that nothing in these Terms will be
          construed to grant You any right to obtain or use such source code;
          (iii) modify, alter, tamper with or repair any of the Materials, or
          create any derivative product from any of the foregoing, or attempt to
          do any of the foregoing, except with Our prior written consent; (iv)
          interfere or attempt to interfere in any manner with the functionality
          or proper working of any of the Materials; (v) remove, obscure, or
          alter any notice of any intellectual property or proprietary right
          appearing on or contained within any of the Materials; (vi) use any
          Open Source Software in connection with any of the Materials in any
          manner that requires, pursuant to the license applicable to such Open
          Source Software, that any of the Materials be (a) disclosed or
          distributed in source code form, (b) made available free of charge to
          recipients, or (c) modifiable without restriction by recipients; (vii)
          assign, sublicense, sell, resell, lease, rent or otherwise transfer or
          convey, or pledge as security or otherwise encumber, Your rights
          granted hereunder; (viii) host, save, preserve, memorialize,
          aggregate, collect, compile, or otherwise retain or store any of the
          Materials (or any copy thereof); or (ix) use the Materials in any
          manner not expressly authorized by these Terms. You will ensure that
          Your use of any of the Materials complies with all applicable laws,
          statutes, regulations or rules and will not use any of the Materials
          in connection with any illegal activities.
        </p>
        <p>
          In addition to Our cancellation rights set forth in these Terms,
          ALBERTai reserves the right, in Our reasonable discretion, to
          temporarily suspend Your access to and use of the Services: (i) during
          planned downtime for upgrades and maintenance to the Services
          (ALBERTai will generally provide notice of such planned downtime on
          the support pages applicable to the Services); (ii) during any
          unavailability caused by circumstances beyond Our reasonable control,
          such as, but not limited to, acts of God, acts of government, acts of
          terror or civil unrest, technical failures beyond our reasonable
          control (including, without limitation, inability to access the
          Internet), or acts undertaken by third parties; or (iii) if We suspect
          or detect any malicious software connected to Your Account or use of
          the Services by You or Your Authorized End Users.
        </p>
        <p>
          We acknowledge that You retain all right, title and interest in and to
          Your Content. You grant to Us the right to use Your Content for
          purposes of making available the Services to You. Notwithstanding
          anything else in these Terms or otherwise, ALBERTai may monitor Your
          use of the Services and use data and information related to such use,
          and Your Content in an aggregate and anonymous manner, including to
          compile statistical and performance information related to the
          provision and operation of the Site and Services (“Aggregated
          Statistics”). As between ALBERTai and You, all right, title and
          interest in the Aggregated Statistics and all intellectual property
          rights therein, belong to and are retained solely by ALBERTai. You
          acknowledge that ALBERTai will be compiling Aggregated Statistics
          based on Your Content input into the Services and You agree that
          ALBERTai may (a) make such Aggregated Statistics publicly available,
          and (b) use such information to the extent and in the manner required
          by applicable law or regulation and for purposes of data gathering,
          analysis, service enhancement and marketing, provided that such data
          and information does not identify You or Your Confidential
          Information.
        </p>

        <h3>MOBILE APPLICATIONS</h3>
        <p>
          We make available applications allowing You to access the Site via a
          mobile device (a “Mobile Application”). To use the Mobile Application
          You must have a mobile device that is compatible with the mobile
          service. We do not warrant that the Mobile Application will be
          compatible with Your mobile device. We hereby grant to You a
          non-exclusive, non-transferable, revocable license to use an object
          code copy of the Mobile Application for one registered account on one
          mobile device owned or leased solely by You, for Your personal use.
          You may not: (i) modify, disassemble, decompile or reverse engineer
          the Mobile Application, except to the extent that such restriction is
          expressly prohibited by law; (ii) rent, lease, loan, resell,
          sublicense, distribute or otherwise transfer the Mobile Application to
          any third-party or use the Mobile Application to provide time sharing
          or similar services for any third-party; (iii) make any copies of the
          Mobile Application; (iv) remove, circumvent, disable, damage or
          otherwise interfere with security-related features of the Mobile
          Application, features that prevent or restrict use or copying of any
          content accessible through the Mobile Application, or features that
          enforce limitations on use of the Mobile Application; or (v) delete
          the copyright and other proprietary rights notices on the Mobile
          Application. You acknowledge that We may from time to time issue
          upgraded versions of the Mobile Application, and may automatically
          electronically upgrade the version of the Mobile Application that You
          are using on Your mobile device. You consent to such automatic
          upgrading on Your mobile device, and agree that these Terms will apply
          to all such upgrades. The foregoing license grant is not a sale of the
          Mobile Application or any copy thereof, and We and Our third-party
          licensors or suppliers retain all right, title, and interest in and to
          the Mobile Application (and any copy of the Mobile Application).
          Standard carrier data charges may apply to Your use of the Mobile
          Application.
        </p>
        <p>
          The following additional terms and conditions apply with respect to
          any Mobile Application that We provide to You designed for use on an
          Apple iOS-powered mobile device (an “iOS App”): (a) (You acknowledge
          that these Terms are between You and Us only, and not with Apple, Inc.
          (“Apple”); (b) Your use of Our iOS App must comply with Apple’s
          then-current App Store Terms of Service; (c) We, and not Apple, are
          solely responsible for Our iOS App and the Services and Content
          available thereon. You acknowledge that Apple has no obligation to
          provide maintenance and support services with respect to Our iOS App.
          To the maximum extent permitted by applicable law, Apple will have no
          warranty obligation whatsoever with respect to Our iOS App; (d) You
          agree that We, and not Apple, are responsible for addressing any
          claims by You or any third-party relating to Our iOS App or Your
          possession and/or use of Our iOS App, including, but not limited to:
          (i) product liability claims; (ii) any claim that the iOS App fails to
          conform to any applicable legal or regulatory requirement; and (iii)
          claims arising under consumer protection or similar legislation, and
          all such claims are governed solely by these Terms and any law
          applicable to Us as provider of the iOS App; (e) You agree that We,
          and not Apple, shall be responsible, to the extent required by these
          Terms, for the investigation, defense, settlement and discharge of any
          third-party intellectual property infringement claim related to Our
          iOS App or Your possession and use of Our iOS App; (f) You represent
          and warrant that (i) You are not located in a country that is subject
          to a U.S. Government embargo, or that has been designated by the U.S.
          Government as a “terrorist supporting” country; and (ii) You are not
          listed on any U.S. Government list of prohibited or restricted
          parties; (g) You agree to comply with all applicable third-party terms
          of agreement when using Our iOS App (e.g., You must not be in
          violation of Your wireless data service terms of agreement when using
          the iOS App); (h) The parties agree that Apple and Apple’s
          subsidiaries are third-party beneficiaries to these Terms as they
          relate to Your license of Our iOS App. Upon Your acceptance of these
          Terms, Apple will have the right (and will be deemed to have accepted
          the right) to enforce these Terms against You as they relate to Your
          license of the iOS App as a third-party beneficiary thereof.
        </p>
        <p>
          The following additional terms and conditions apply with respect to
          any Mobile Application that We provide to You designed for use on an
          Android-powered mobile device (an “Android App”): (a) You acknowledge
          that these Terms are between You and Us only, and not with Google,
          Inc. (“Google”); (b) Your use of Our Android App must comply with
          Google’s then-current Android Market Terms of Service; (c) Google is
          only a provider of the Android Market where You obtained the Android
          App. We, and not Google, are solely responsible for Our Android App
          and the Services and Content available thereon. Google has no
          obligation or liability to You with respect to Our Android App or
          these Terms; (d) You acknowledge and agree that Google is a
          third-party beneficiary to the Terms as they relate to Our Android
          App.
        </p>

        <h3>CANCELLATION OR TERMINATION OF ACCOUNT</h3>
        <p>
          You may cancel your Account at any time by emailing us at
          info@myalbertai.com. You agree and acknowledge that upon
          cancellation, ALBERTai may immediately suspend Your Account. ALBERTai
          reserves the right to delete all Your Content and any other data in
          the normal course of operation.
        </p>
        <p>
          ALBERTai reserves the right to modify, suspend or terminate the
          Services (or any part thereof), Your Account and/or Your right to
          access and use the Site or Services, and remove, disable and discard
          any of Your Content if we believe that You or Your Authorized End
          Users have violated these Terms. Unless legally prohibited from doing
          so, We will use commercially reasonable efforts to contact You
          directly via email to notify You when taking any of the foregoing
          actions. ALBERTai shall not be liable to You, Your Authorized End
          Users or any other third party for any such modification, suspension
          or discontinuation of Your rights to access and use the Services.
        </p>

        <h3>ELECTRONIC COMMUNICATIONS</h3>
        <p>
          By using the Site and/or the Services provided on or through the Site,
          You consent to receiving electronic communications from Us. These
          electronic communications may include notices about applicable fees
          and charges, transactional information and other information
          concerning or related to the Site and/or Services provided on or
          through the Site. These electronic communications are part of Your
          relationship with Us. You agree that any notices, agreements,
          disclosures or other communications that We send You electronically
          will satisfy any legal communication requirements, including that such
          communications be in writing.
        </p>

        <h3>PRIVACY POLICY, SECURITY, AND CONFIDENTIALITY</h3>
        <p>
          We respect the information that You provide to Us, and want to be sure
          You fully understand exactly how We use that information. So, please
          review Our Privacy Policy (“Privacy Policy”), available at
          https://goalalbertai.com/privacy/ which explains everything.
        </p>
        <p>
          You are responsible for maintaining the confidentiality of Your
          Account passwords, and You are responsible for all activities that
          occur using your Account passwords. You agree not to share Your
          Account passwords, let others access or use Your Account or do
          anything else that might jeopardize the security of Your Account
          passwords. You agree to notify ALBERTai if Your Account passwords are
          lost, stolen, if You are aware of any unauthorized use of Your Account
          passwords on the Site or if You know of any other breach of security
          in relation to the Site.
        </p>
        <p>
          You and ALBERTai agree as follows with respect to Confidential
          Information: (i) to use Confidential Information disclosed by the
          other party only for the purposes described herein; (ii) to not
          reproduce Confidential Information of the other party, and to hold in
          confidence and protect such Confidential Information from
          dissemination to, and use by, any third party; (iii) to not create any
          derivative work from the Confidential Information of the other party;
          (iv) to restrict access to the Confidential Information of the other
          party to its personnel, agents, and/or consultants, who have a need to
          have access and who have been advised of and have agreed in writing to
          treat such Confidential Information in accordance with these Terms;
          and (v) to return or destroy all Confidential Information disclosed by
          the other party that is in its possession upon termination or
          expiration of the Account or Services. Notwithstanding the foregoing,
          the obligations contained in this paragraph will not apply to
          Confidential Information that (i) is publicly available or in the
          public domain at the time disclosed; (ii) is or becomes publicly
          available or enters the public domain through no fault of the
          recipient; (iii) is rightfully communicated to the recipient by
          persons not bound by confidentiality obligations with respect thereto;
          (iv) is already in the recipient’s possession free of any
          confidentiality obligations with respect thereto at the time of
          disclosure; (v) is independently developed by the recipient; or (vi)
          is approved for release or disclosure by the disclosing party without
          restriction. Notwithstanding the foregoing, each party may disclose
          Confidential Information to the limited extent required (x) in order
          to comply with the order of a court or other governmental body, or as
          otherwise necessary to comply with applicable law, provided that the
          party making the disclosure pursuant to the order shall first have
          given written notice to the other party and made a reasonable effort
          to obtain a protective order; or (y) to establish a party’s rights
          under these Terms, including to make such court filings as it may be
          required to do.
        </p>

        <h3>LINKS TO THIRD-PARTY SITES</h3>
        <p>
          We think links are convenient, and We sometimes provide links on his
          Site to third-party Sites. If You use these links, You will leave the
          Site. We are not obligated to review any third-party Sites that You
          link to from the Site, We do not control any of the third-party Sites,
          and We are not responsible for any of the third-party Sites (or the
          products, services, or content available through any of them). Thus,
          We do not endorse or make any representations about such third-party
          Sites, any information, software, products, services, or materials
          found there or any results that may be obtained from using them. If
          You decide to access any of the third-party Sites linked to from the
          Site, You do this entirely at Your own risk and You must follow the
          privacy policies and terms and conditions for those third-party Sites.
          Certain areas of the Site may allow You to interact and/or conduct
          transactions with one or more third-party Sites, and, if applicable,
          allow you to configure your privacy settings in that third-party Site
          account to permit Your activities on the Site to be shared with Your
          contacts in your third-party site account.
        </p>

        <h3>UNAUTHORIZED ACTIVITIES</h3>
        <p>
          To be clear, We authorize Your use of the Site only for Permitted
          Purposes. Any other use of the Site beyond the Permitted Purposes is
          prohibited and, therefore, constitutes unauthorized use of the Site.
          This is because as between You and Us, all rights in the Site remain
          Our property.
        </p>
        <p>
          Unauthorized use of the Site may result in violation of various United
          States and international copyright laws. Because We prefer keeping
          this relationship drama-free, We want to give You examples of things
          to avoid. So, unless You have written permission from Us stating
          otherwise, You are not authorized to use the Site in any of the
          following ways (these are examples only and the list below is not a
          complete list of everything that You are not permitted to do): (a) For
          any public or commercial purpose which includes use of the Site on
          another site or through a networked computer environment; (b) In a
          manner that modifies, publicly displays, publicly performs, reproduces
          or distributes any of the Site; (c) In a manner that violates any
          local, state, national, foreign, or international statute, regulation,
          rule, order, treaty, or other law; (d) To stalk, harass, or harm
          another individual; (e) To impersonate any person or entity or
          otherwise misrepresent Your affiliation with a person or entity; (f)
          To interfere with or disrupt the Site or servers or networks connected
          to the Site; (g) To use any data mining, robots, or similar data
          gathering or extraction methods in connection with the Site; or (h) To
          attempt to gain unauthorized access to any portion of the Site or any
          other accounts, computer systems, or networks connected to the Site,
          whether through hacking, password mining, or any other means.
        </p>
        <p>
          You also agree and understand that as pertaining those sections of the
          Site that may allow you to publicly post comments or content, You as
          the author are entirely responsible for the content of, and any harm
          resulting from, any public content posted or uploaded by you. That is
          the case regardless of whether Your Content in question constitutes
          text, graphics, audio files, information, or computer software. By
          making Your Content publicly available, you represent and warrant
          that:
        </p>
        <ul>
          <li>
            The posting, downloading, copying and use of Your Content will not
            infringe the proprietary rights, including but not limited to the
            copyright, patent, trademark or trade secret rights, of any third
            party;
          </li>
          <li>
            (b) Your Content does not contain or install any viruses, worms,
            malware, Trojan horses or other harmful or destructive content;
          </li>
          <li>
            (c) Your Content is not spam, is not machine- or randomly-generated,
            and does not contain unethical or unwanted commercial content
            designed to drive traffic to third party sites or boost the search
            engine rankings of third party sites, or to further unlawful acts
            (such as phishing) or mislead recipients as to the source of the
            material (such as spoofing);
          </li>
          <li>
            (d) Your Content does not contain threats or incite violence towards
            individuals or entities, and does not violate the privacy or
            publicity rights of any third party;
          </li>
          <li>
            (e) Your Content is not getting advertised via unwanted electronic
            messages such as spam links on newsgroups, email lists, other blogs
            and web sites, and similar unsolicited promotional methods;
          </li>
          <li>
            (f) Your Content is not named in a manner that misleads your readers
            into thinking that you are another person or company;
          </li>
          <li>
            (g) Your Content does not include racially, ethnically, obscene,
            sexually explicit or otherwise offensive language or use the Website
            to discuss, incite illegal activity or promote hatred against
            individuals or groups based on race, ethnic origin, religion,
            disability, gender, age, veteran status, sexual orientation, or
            gender identity. You agree to indemnify, defend and hold ALBERTai
            and Unity harmless from and against all damages, losses, claims and
            costs (including reasonable attorneys’ fees) incurred by ALBERTai
            and Unity as a result of your placement of Your Content on the Site.
          </li>
        </ul>

        <h3>SPECIFIC TERMS FOR CBOs</h3>
        <p>
          In addition to all of the other Terms in these Terms, CBOs, and the
          Authorized End Users who use our Site and Services on their behalf are
          subject to the additional requirements described in this section.
          These Terms are important to protect ALBERTai and Unity, and our
          partner organizations, while still allowing us to provide the Site and
          Services to CBOs, for free, without needing to engage in a lengthy
          contracting process.
        </p>
        <p>
          By claiming a CBO on our Site, either through the workflow maintained
          at https://www.goalbertai.com/claims or through any other method that
          may now or in the future become available, You represent and warrant
          that You are authorized to act on Your own behalf, and on the behalf
          of the CBO that You are claiming and its Authorized End Users
          (collectively “Your CBO”), and to bind Your CBO to these Terms. CBOs
          and their Authorized End Users are granted access to certain
          functionality through our Site to help the CBO with intake management,
          appointment scheduling, communication and other tasks related to
          individuals who are seeking services from them (“CBO Tools”). CBO
          Tools and their use by Authorized End Users are subject to all terms
          of these Terms, in addition to any supplemental terms related to
          specific functionality described in this section.
        </p>
        <p>
          You understand that by using the Site and Services, Your CBO will be
          granted access to referrals and inquiries made by or on behalf of
          other Authorized End Users of the Site and Services who may be seeking
          help from Your CBO. These referrals are content generated by, and are
          the exclusive property of the Authorized End Users who submit them.
          ALBERTai and Unity has and is able to grant you the limited license
          described in these Terms, to use any inquiry or referral only for the
          purpose of making further contact with the Authorized End User who
          submitted it, or the individual who is the subject of the inquiry or
          referral. Your CBO is not permitted to use any inquiry or referral for
          any other purpose, unless that purpose is explicitly authorized by
          ALBERTai and Unity, the Authorized End User who submitted it, or the
          individual who is the subject of the inquiry or referral. Obtaining
          consent from the appropriate individual(s) for any other use of
          referrals or inquiries Your responsibility. You agree that between
          Your CBO and ALBERTai and Unity, Your CBO is solely liable for its use
          of any referrals or inquiries sent to it, whether or not such use is
          not explicitly authorized by these Terms. ALBERTai reserves the right,
          but does not have any obligation, to terminate these Terms according
          to the terms of Section, if we discover that Your CBO is misusing
          referrals or inquiries from other Authorized End Users.
        </p>
        <p>
          By claiming Your CBO, you will be granted access to make modifications
          or updates to the information on the Site related to Your CBO. Any
          information about Your CBO that you upload to the Site is Your Content
          and is subject to all other terms of these Terms related to Your
          Content.
        </p>
        <p>
          In certain circumstances, you may be granted the functionality to
          reply directly to a referral or inquiry made by an Authorized End User
          that represents a health care or care management organization. If you
          make use of this functionality, you agree to grant the Authorized End
          User, and the organization that the Authorized End User represents, if
          any, a non-exclusive, perpetual, irrevocable, and royalty-free license
          to use your reply for the purposes of maintaining or updating medical
          or other records held by that Authorized End User, and for any other
          purpose related to the care of or providing services to the individual
          who is the subject of the referral or inquiry. This license will
          survive the termination of these Terms for any reason.
        </p>
        <p>
          ALBERTai and Unity is aware that some CBOs provide services to
          individuals where the records related to those services are subject to
          the privacy requirements established in 42 CFR Part 2 –
          Confidentiality of Substance Use Disorder Patient Records. If Your CBO
          provides such services, You agree that Your CBO is solely liable for
          maintaining compliance with 42 CFR Part 2, including but not limited
          to collecting proper written or electronic consent from any individual
          where such consent is necessary to further disclose that individual’s
          information for any purpose. While we may provide You with
          communication tools related to the services that Your CBO provides, it
          is Your CBO’s responsibility to ensure that those tools, and any other
          CBO Tools, are used in compliance with all applicable laws and
          regulations, including 42 CFR Part 2.
        </p>

        <h3>PROPRIETARY RIGHTS</h3>
        <p>
          “ALBERTai and Unity” is a trademark that belongs to Us. Other
          trademarks, names and logos on the Site are the property of their
          respective owners. Unless otherwise specified in these Terms, all
          Materials, including the arrangement of them on the Site are the sole
          property of Unity, a Limited Liability Company. All rights not
          expressly granted herein are reserved. Except as otherwise required or
          limited by applicable law, any reproduction, distribution,
          modification, retransmission, or publication of any copyrighted
          material is strictly prohibited without the express written consent of
          the copyright owner or license.
        </p>
        <p>
          All right, title and interest in the Site, Services and any other
          Materials furnished or made available hereunder, including without
          limitation all data generated from Your use of the Materials, Site,
          and Services, and all modifications and enhancements thereof, and all
          suggestions, ideas and feedback proposed by You regarding the
          Materials, Site, and Services, including all copyright rights, patent
          rights and other intellectual property rights in each of the
          foregoing, belong to and are retained solely by ALBERTai and Unity or
          ALBERTai and Unity’s licensors and providers, as applicable. You
          hereby do and will irrevocably assign to ALBERTai all evaluations,
          ideas, feedback and suggestions made by You whether by transmitted to
          ALBERTai and Unity by phone, email, or otherwise regarding the Site,
          Materials, and Services (collectively, “Feedback”) and all
          intellectual property rights in the Feedback.
        </p>

        <h3>INTELLECTUAL PROPERTY INFRINGEMENT</h3>
        <p>
          We respect the intellectual property rights of others and encourage
          You to do the same. Accordingly, We have a policy of removing content
          that violates intellectual property rights of others, suspending
          access to the Site (or any portion thereof) to any user who uses the
          Site in violation of someone’s intellectual property rights, and/or
          terminating in appropriate circumstances the Account of any user who
          uses the Site in violation of someone’s intellectual property rights.
        </p>
        <p>
          Pursuant to Title 17 of the United States Code, Section 512, We have
          implemented procedures for receiving written notification of claimed
          copyright infringement and for processing such claims in accordance
          with such law. If You believe Your copyright or other intellectual
          property right is being infringed by a user of the Site, please
          provide written notice to Our Management for notice of claims of
          infringement:
        </p>
        <p>Unity Global Care Inc.</p>
        <p>203 Main Street #179</p>
        <p>Flemington, NJ 08822</p>
        <p>
          <strong>Notices.</strong> To be sure the matter is handled
          immediately, Your written notice must: (a) Contain Your physical or
          electronic signature; (b) Identify the copyrighted work or other
          intellectual property alleged to have been infringed; (c) Identify the
          allegedly infringing material in a sufficiently precise manner to
          allow Us to locate that material; (d) Contain adequate information by
          which We can contact You (including postal address, telephone number,
          and e-mail address); (e) Contain a statement that You have a good
          faith belief that use of the copyrighted material or other
          intellectual property is not authorized by the owner, the owner’s
          agent or the law; (f) Contain a statement that the information in the
          written notice is accurate; and (g) Contain statement, under penalty
          of perjury, that You are authorized to act on behalf of the copyright
          or other intellectual property right owner.
        </p>
        <p>
          Unless the notice pertains to copyright or other intellectual property
          infringement, the Agent will be unable to address the listed concern.
        </p>
        <p>
          <strong>Submitting a DMCA Counter-Notification.</strong> We will
          notify You that We have removed or disabled access to
          copyright-protected material that You provided, if such removal is
          pursuant to a validly received DMCA take-down notice. In response, You
          may provide Our Agent with a written counter-notification that
          includes the following information: 1. Your physical or electronic
          signature; 2. Identification of the material that has been removed or
          to which access has been disabled, and the location at which the
          material appeared before it was removed or access to it was disabled;
          3. A statement from You under the penalty of perjury, that You have a
          good faith belief that the material was removed or disabled as a
          result of a mistake or misidentification of the material to be removed
          or disabled; and 4. Your name, physical address and telephone number,
          and a statement that You consent to the jurisdiction of a court for
          the judicial district in which Your physical address is located, or if
          Your physical address is outside of the United States, for any
          judicial district in which We may be located, and that You will accept
          service of process from the person who provided notification of
          allegedly infringing material or an agent of such person.
        </p>
        <p>
          <strong>Termination of Repeat Infringers.</strong> We reserve the
          right, in Our sole discretion, to terminate the Account or access of
          any user of the Site or Service who is the subject of repeated DMCA or
          other infringement notifications.
        </p>

        <h3>INDEMNITY</h3>
        <p>
          You agree to hire attorneys to defend Us against any claims by third
          parties related to or in connection with: (i) Your negligence or
          willful misconduct; (ii) Your or Your Authorized End Users’ violation
          of these Terms; (iii) Your and Your Authorized End Users’ use of the
          Site or Services; or (iv) any products or services offered or
          otherwise provided by You; or (v) any violation of applicable local,
          state, or federal laws or regulations by You and Your Authorized End
          Users. You also agree to pay any damages that We may end up having to
          pay as a result of Your violation. You alone are responsible for any
          violation of these Terms by You or Your Authorized End Users. We
          reserve the right to assume the exclusive defense and control of any
          matter otherwise subject to indemnification by You and, in such case,
          You agree to cooperate with Our defense of such claim.
        </p>

        <h3>DISCLAIMER OF WARRANTIES</h3>
        <p>
          THE SITE, THE SERVICES, AND MATERIALS ARE PROVIDED “AS IS” AND “WITH
          ALL FAULTS” AND THE ENTIRE RISK AS TO THE QUALITY AND PERFORMANCE OF
          THE SITE IS WITH YOU. WE EXPRESSLY DISCLAIM ALL WARRANTIES OF ANY KIND
          (EXPRESS, IMPLIED OR STATUTORY) WITH RESPECT TO THE SITE, SERVICES,
          AND MATERIALS WHICH INCLUDES BUT IS NOT LIMITED TO, ANY IMPLIED OR
          STATUTORY WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR USE
          OR PURPOSE, TITLE, AND NON-INFRINGEMENT OF INTELLECTUAL PROPERTY
          RIGHTS. THIS MEANS THAT WE DO NOT PROMISE YOU THAT THE SITE, SERVICES,
          AND MATERIALS ARE FREE OF PROBLEMS. Without limiting the generality of
          the foregoing, We make no warranty that the Site or Services will meet
          Your requirements or that the Site or Services will be uninterrupted,
          timely, secure, or error free or that defects in the Site will be
          corrected. We make no warranty as to the results that may be obtained
          from the use of the Site or Services or as to the accuracy or
          reliability of any information obtained through the Site or Services.
          No advice or information, whether oral or written, obtained by You
          through the Site or from Us or Our (or Our subsidiaries, licensors,
          agents, or affiliated companies) shall create any warranty. We
          disclaim all equitable indemnities.
        </p>

        <h3>LIMITATION OF LIABILITY</h3>
        <p>
          IN NO EVENT WILL ALBERTAI AND UNITY HEALTHCARE INTELLIGENCE LLC (OR
          ITS AFFILIATES, SUBSIDIARIES, LICENSORS OR AGENTS) BE LIABLE TO YOU
          FOR ANY INCIDENTAL, INDIRECT, SPECIAL, CONSEQUENTIAL OR PUNITIVE
          DAMAGES, REGARDLESS OF THE NATURE OF THE CLAIM, INCLUDING, WITHOUT
          LIMITATION, LOST PROFITS, COSTS OF DELAY, ANY FAILURE OF DELIVERY,
          BUSINESS INTERRUPTION, COSTS OF LOST OR DAMAGED DATA OR DOCUMENTATION,
          OR LIABILITIES TO THIRD PARTIES ARISING FROM ANY SOURCE, EVEN IF
          ALBERTAI AND UNITY HEALTHCARE INTELLIGENCE LLC HAS BEEN ADVISED OF THE
          POSSIBILITY OF SUCH DAMAGES. THIS LIMITATION UPON DAMAGES AND CLAIMS
          IS INTENDED TO APPLY WITHOUT REGARD TO WHETHER OTHER PROVISIONS OF
          THIS AGREEMENT HAVE BEEN BREACHED OR HAVE PROVEN INEFFECTIVE.
        </p>
        <p>
          THE CUMULATIVE LIABILITY OF ALBERTAI AND UNITY HEALTHCARE INTELLIGENCE
          LLC (OR ITS AFFILIATES, SUBSIDIARIES, LICENSORS OR AGENTS) TO YOU FOR
          ALL CLAIMS ARISING FROM OR RELATING TO THESE TERMS, INCLUDING, WITHOUT
          LIMITATION, ANY CAUSE OF ACTION SOUNDING IN CONTRACT, TORT, OR STRICT
          LIABILITY, WILL NOT EXCEED THE TOTAL AMOUNT OF $500. THIS LIMITATION
          OF LIABILITY IS INTENDED TO APPLY WITHOUT REGARD TO WHETHER OTHER
          PROVISIONS OF THIS AGREEMENT HAVE BEEN BREACHED OR HAVE PROVEN
          INEFFECTIVE.
        </p>

        <h3>LOCAL LAWS; EXPORT CONTROL</h3>
        <p>
          We control and operate the Site from Our headquarters in the United
          States of America and the entirety of the Site may not be appropriate
          or available for use in other locations. If You use the Site outside
          the United States of America, You are solely responsible for following
          applicable local laws.
        </p>

        <h3>GENERAL</h3>
        <p>
          We think direct communication resolves most issues – if We feel that
          You are not complying with these Terms, We will tell You. We will even
          provide You with recommended necessary corrective action(s) because We
          value this relationship. However, certain violations of these Terms,
          as determined by Us, may require immediate termination of Your access
          to the Site without prior notice to You.
        </p>
        <p>
          Delaware state law and applicable U.S. federal law, without regard to
          the choice or conflicts of law provisions, will govern these Terms.
          Foreign laws do not apply. Any disputes relating to these Terms or the
          Site will be heard in the courts located in a city of our choosing in
          the state of Delaware. If any of these Terms are deemed inconsistent
          with applicable law, then such term(s) shall be interpreted to reflect
          the intentions of the parties, and no other terms will be modified. By
          choosing not to enforced any of these Terms, We are not waiving Our
          rights. These Terms are the entire agreement between You and Us and,
          therefore, supersede all prior or contemporaneous negotiations,
          discussions, or agreements between Everyone about the Site. The
          proprietary rights, disclaimer of warranties, representations made by
          You, indemnities, limitations of liability and general provisions
          shall survive any termination of these Terms.
        </p>

        <h3>CONTACT US</h3>
        <p>
          If You have any questions about these Terms or otherwise need to
          contact Us for any reason, You can reach Us at info@myalbertai.com.
        </p>
      </div>
      {/* Close main content wrapper */}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
